import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faLockOpen,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../../i18n/LanguageContext";

function ActivityTab({
  member,
  consentStatus,
  onViewDashboard,
  onViewAnalyses,
  onViewReports,
}) {
  const { t } = useTranslation();

  const dashboardGranted = consentStatus?.dashboardAccess || false;
  const analysisGranted = consentStatus?.analysisAccess || false;
  const reportsGranted = consentStatus?.reportsAccess || false;

  const memberName = member
    ? `${member.firstName} ${member.lastName}`
    : t("usermgmt.activity.thisMember");

  return (
    <div className="um-activity-tab">
      {/* Dashboard */}
      <div className="um-activity-row">
        <div className="um-activity-row-left">
          <div className="um-activity-info">
            <span className="um-activity-label">
              {t("usermgmt.activity.dashboard")}
            </span>
            <span
              className={`um-consent-badge ${dashboardGranted ? "granted" : "not-granted"}`}
            >
              <FontAwesomeIcon icon={dashboardGranted ? faLockOpen : faLock} />
              {dashboardGranted
                ? t("usermgmt.activity.consentGranted")
                : t("usermgmt.activity.consentNotGranted")}
            </span>
          </div>
        </div>
        <button
          className="common-button small primary um-activity-view-btn"
          onClick={() => onViewDashboard && onViewDashboard(member)}
          disabled={!dashboardGranted}
          title={
            dashboardGranted
              ? t("usermgmt.activity.viewDashboardTitle").replace(
                  "{name}",
                  memberName,
                )
              : t("usermgmt.activity.noAccessTitle").replace(
                  "{name}",
                  memberName,
                )
          }
        >
          {dashboardGranted ? (
            <>
              <FontAwesomeIcon icon={faArrowRight} />
              {t("usermgmt.activity.viewDashboard")}
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faLock} />
              {t("usermgmt.activity.noAccess")}
            </>
          )}
        </button>
      </div>

      {/* Analyses */}
      <div className="um-activity-row">
        <div className="um-activity-row-left">
          <div className="um-activity-info">
            <span className="um-activity-label">
              {t("usermgmt.activity.analysesDetail")}
            </span>
            <span
              className={`um-consent-badge ${analysisGranted ? "granted" : "not-granted"}`}
            >
              <FontAwesomeIcon icon={analysisGranted ? faLockOpen : faLock} />
              {analysisGranted
                ? t("usermgmt.activity.consentGranted")
                : t("usermgmt.activity.consentNotGranted")}
            </span>
          </div>
        </div>
        <button
          className="common-button small primary um-activity-view-btn"
          onClick={() => onViewAnalyses && onViewAnalyses(member)}
          disabled={!analysisGranted}
          title={
            analysisGranted
              ? t("usermgmt.activity.viewAnalysesTitle").replace(
                  "{name}",
                  memberName,
                )
              : t("usermgmt.activity.noAccessTitle").replace(
                  "{name}",
                  memberName,
                )
          }
        >
          {analysisGranted ? (
            <>
              <FontAwesomeIcon icon={faArrowRight} />
              {t("usermgmt.activity.viewAnalyses")}
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faLock} />
              {t("usermgmt.activity.noAccess")}
            </>
          )}
        </button>
      </div>

      {/* Reports */}
      <div className="um-activity-row">
        <div className="um-activity-row-left">
          <div className="um-activity-info">
            <span className="um-activity-label">
              {t("usermgmt.activity.reports")}
            </span>
            <span
              className={`um-consent-badge ${reportsGranted ? "granted" : "not-granted"}`}
            >
              <FontAwesomeIcon icon={reportsGranted ? faLockOpen : faLock} />
              {reportsGranted
                ? t("usermgmt.activity.consentGranted")
                : t("usermgmt.activity.consentNotGranted")}
            </span>
          </div>
        </div>
        <button
          className="common-button small primary um-activity-view-btn"
          onClick={() => onViewReports && onViewReports(member)}
          disabled={!reportsGranted}
          title={
            reportsGranted
              ? t("usermgmt.activity.viewReportsTitle").replace(
                  "{name}",
                  memberName,
                )
              : t("usermgmt.activity.noAccessTitle").replace(
                  "{name}",
                  memberName,
                )
          }
        >
          {reportsGranted ? (
            <>
              <FontAwesomeIcon icon={faArrowRight} />
              {t("usermgmt.activity.viewReports")}
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faLock} />
              {t("usermgmt.activity.noAccess")}
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default ActivityTab;
